module.exports = __webpack_public_path__ + "assets/img/alipay.b9754e2d.png";